import { ADICIONA_REMOVE_IMAGENS_ENCOMENDA } from '../types'

export default function adicionaEhRemoveImagensEncomenda (arquivos) {
  return {
    type: ADICIONA_REMOVE_IMAGENS_ENCOMENDA,
    payload: arquivos
  }
}